/**
 * Filters menu
 */

export default function filters() {

  const targets = Array.from(document.querySelectorAll('[data-js="filterMenuTrigger"]'));


  // When trigger for menu exists
  if (targets.length > 0) {

    // Show menu on click
    var trigger = function () {
      targets.forEach(target => {
        target.addEventListener('click', toggleMenu);
      });
    };
    trigger();

    function toggleMenu(e) {
      if(e.target.classList.contains('filterBtn')) {
        if(e.target.querySelector('.filterMenu').classList.contains('is-open')) {
          e.target.querySelector('.filterMenu').classList.remove('is-open');
        
        } else {
          targets.forEach(target => {
            target.querySelector('.filterMenu').classList.remove('is-open');
          });
          e.target.querySelector('.filterMenu').classList.add('is-open');
        }
      }
    }
   

  }

}
